/* @ngInject */
export default class DashboardService {
    constructor() {
        this.dashboardModules = [
            {
                name: 'Start Project',
                path: 'app/dashboard/startProject.html',
                isEnabled: false,
            },
            {
                name: 'Action Items',
                path: 'app/dashboard/dashboardToDoList.html',
                isEnabled: false,
            },
            {
                name: 'Pipeline Summary',
                path: 'app/pipelineSummary/pipelineSummary.html',
                isEnabled: false,
            },
            {
                name: 'Coming Soon',
                path: 'app/dashboard/comingSoon.html',
                isEnabled: false,
            }];
    }

    getDashboard() {
        return this.dashboardModules;
    }
}

// function dashboardFactory() {
//   const dashboardModules = [
//     {
//       name: 'Start Project',
//       path: 'app/dashboard/startProject.html',
//       isEnabled: false,
//     },
//     {
//       name: 'Action Items',
//       path: 'app/dashboard/dashboardToDoList.html',
//       isEnabled: false,
//     },
//     {
//       name: 'Pipeline Summary',
//       path: 'app/pipelineSummary/pipelineSummary.html',
//       isEnabled: false,
//     },
//     {
//       name: 'Coming Soon',
//       path: 'app/dashboard/comingSoon.html',
//       isEnabled: false,
//     }];

//   return {
//     getDashboard,
//   };

//   function getDashboard() {
//     return dashboardModules;
//   }
// }




// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.service.js